// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"FooterApp_footerWrapper__2Ui5_","copyright":"FooterApp_copyright__1HYG2","supportLink":"FooterApp_supportLink__1rXt5"};